import { useEffect } from 'react'
import { DrawerProps } from '@mui/material'

/** Overlay drawer: no layout shift; page stays clickable outside the panel (same pattern as AppMenu). */
export const sideBarOverlayDrawerProps: Partial<DrawerProps> = {
    modal: false,
    hideBackdrop: true,
    disableScrollLock: true,
    disableEnforceFocus: true,
    disableAutoFocus: true,
    disableRestoreFocus: true,
    sx: {
        pointerEvents: 'none'
    },
    ModalProps: {
        disableEnforceFocus: true,
        disableAutoFocus: true,
        disableRestoreFocus: true,
        disableScrollLock: true,
        sx: {
            pointerEvents: 'none'
        }
    }
}

export const sideBarOverlayDrawerPaperSx = {
    pointerEvents: 'auto',
    backgroundImage: 'none !important',
    width: '50%',
    borderLeft: (theme: { palette: { divider: string } }) => `1px solid ${theme.palette.divider}`
}

export const sideBarOverlayDrawerPaperProps: DrawerProps['PaperProps'] = {
    sx: sideBarOverlayDrawerPaperSx
}

export const createOverlayDrawerOnClose = (onClose: () => void): NonNullable<DrawerProps['onClose']> =>
    (_event, reason) => {
        if (reason === 'escapeKeyDown') {
            onClose()
        }
    }

/** `modal={false}` drawers do not always receive MUI escape handling — listen on document. */
export const useSideBarOverlayDrawerEscape = (open: boolean, onClose: () => void) => {
    useEffect(() => {
        if (!open) return

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key !== 'Escape') return
            event.preventDefault()
            onClose()
        }

        document.addEventListener('keydown', handleKeyDown, true)
        return () => document.removeEventListener('keydown', handleKeyDown, true)
    }, [open, onClose])
}
